<template>
    <div>
        <template v-if="condaUseV2FrontendPortfolioDashboard">
            <PortfolioDashboard />
        </template>
        <template v-else>
            <AccountPersonalOverviewPersonalData></AccountPersonalOverviewPersonalData>
            <AccountPersonalOverviewAddressData></AccountPersonalOverviewAddressData>
            <AccountPersonalOverviewContactData></AccountPersonalOverviewContactData>
        </template>
    </div>
</template>

<script setup lang="ts">
import PortfolioDashboard from '../portfolio/PortfolioDashboard.vue'
import AccountPersonalOverviewPersonalData from './overview/AccountPersonalOverviewPersonalData.vue'
import AccountPersonalOverviewAddressData from './overview/AccountPersonalOverviewAddressData.vue'
import AccountPersonalOverviewContactData from './overview/AccountPersonalOverviewContactData.vue'
import { ref, watchEffect } from 'vue'

const condaUseV2FrontendPortfolioDashboard = ref<number>(0)

watchEffect(() => {
    condaUseV2FrontendPortfolioDashboard.value = window.condaUseV2FrontendPortfolioDashboard
})
</script>

<style scoped></style>
